import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.unresolvedComments.length ||
      _vm.resolvedComments.length ||
      _vm.permission.addComment
        ? _c(
            VRow,
            [
              _c(VSpacer),
              _vm._v(" "),
              _vm.unresolvedComments.length || _vm.permission.addComment
                ? _c(
                    "button",
                    {
                      staticClass: "toggle-unresolved-btn mr-2",
                      attrs: {
                        title: "Unresolved Comment(s)",
                        active: _vm.showUnresolved,
                      },
                      on: {
                        click: function ($event) {
                          _vm.showUnresolved = !_vm.showUnresolved
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _vm.unresolvedComments.length
                              ? _vm.unresolvedComments.length
                              : ""
                          ) +
                          "\n      "
                      ),
                      !_vm.showUnresolved
                        ? _c("i", {
                            staticClass: "v-icon mdi mdi-message-outline",
                          })
                        : _c("i", { staticClass: "v-icon mdi mdi-message" }),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.resolvedComments.length
                ? _c(
                    "button",
                    {
                      staticClass: "toggle-resolved-btn mr-2",
                      attrs: {
                        title: "Resolved Comment(s)",
                        active: _vm.showResolved,
                      },
                      on: {
                        click: function ($event) {
                          _vm.showResolved = !_vm.showResolved
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _vm.resolvedComments.length
                              ? _vm.resolvedComments.length
                              : ""
                          ) +
                          "\n      "
                      ),
                      !_vm.showResolved
                        ? _c("i", {
                            staticClass: "v-icon mdi mdi-message-check-outline",
                          })
                        : _c("i", {
                            staticClass: "v-icon mdi mdi-message-check",
                          }),
                    ]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showResolved || _vm.showUnresolved
        ? _c(
            "div",
            {
              staticClass: "section row",
              class: _vm.showResolved ? "section--resolved" : "",
            },
            [
              _vm._l(_vm.c_value, function (c) {
                return _c(
                  "div",
                  { key: c.id, staticClass: "section-item col-12" },
                  [
                    _c("comment-item", {
                      staticClass: "comment-item",
                      attrs: {
                        comment: c,
                        "show-input": _vm.showUnresolved,
                        "current-user-id": _vm.currentUserId,
                        "users-data": _vm.usersData,
                      },
                      on: {
                        resolveComment: function ($event) {
                          return _vm.$emit("resolveComment", $event)
                        },
                        replyComment: function ($event) {
                          return _vm.$emit("replyComment", $event)
                        },
                        editComment: function ($event) {
                          return _vm.$emit("editComment", $event)
                        },
                        deleteComment: function ($event) {
                          return _vm.$emit("deleteComment", $event)
                        },
                      },
                    }),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _vm.showUnresolved && _vm.permission.addComment
                ? _c("div", { staticClass: "row" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.inputComment,
                          expression: "inputComment",
                        },
                      ],
                      staticClass: "section-input col",
                      attrs: { placeholder: "Add Comment  Here ..." },
                      domProps: { value: _vm.inputComment },
                      on: {
                        keydown: _vm.enterToSend,
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.inputComment = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "section-send col-1",
                        attrs: { title: "Send", disabled: !_vm.inputComment },
                        on: {
                          click: function ($event) {
                            return _vm.sendComment()
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "v-icon mdi mdi-send",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ]
                    ),
                  ])
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }